import React from 'react';

export const columns = [
  {field: 'english', headerName: 'English', flex: 1, minWidth: 100, description: 'English Name',},
  {field: 'phonetic', headerName: 'Phonetic', flex: 1, minWidth: 100, maxWidth: 300,},
  {field: 'thai', headerName: 'Thai', flex: 1, minWidth: 100,},
  {field: 'search', headerName: 'Search', flex: 1, minWidth: 100,},
];